import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";

export const getClientInfoApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getClientInfo: builder.query<ISurveyData, void>({
            query: () => {
                return {
                    url: apiPath.applications.client.base,
                    method: "GET"
                };
            },
            transformErrorResponse: (response) => {
                return getIgnoredNotifyResponse(response, [404]);
            }
        })
    })
});

export const {useGetClientInfoQuery} = getClientInfoApi;
import {apiPath} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {ISurveyData} from "../../user/types/IBuildSurveyParams";

export const getClientInfoApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getClientInfo: builder.query<ISurveyData, void>({
            query: () => {
                return {
                    url: apiPath.applications.client.base,
                    method: "GET"
                };
            },
            transformErrorResponse: (response) => {
                return getIgnoredNotifyResponse(response, [404]);
            }
        })
    })
});

export const {useGetClientInfoQuery} = getClientInfoApi;
